/**
 * Upsell Quick-Add Modal — Variant Switch Fix
 *
 * Handles image swap and form input update when switching variants
 * in the quick-add upsell modal. Uses event delegation so it works
 * regardless of when the modal content is injected into the DOM.
 */
(function () {
  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (radio.type !== 'radio') return;

    var modal = radio.closest('[data-quick-add-modal]');
    if (!modal) return;

    var productInfo = radio.closest('product-info');
    if (!productInfo) return;

    var dataScript = productInfo.querySelector('[data-upsell-variant-map]');
    if (!dataScript) return;

    var variants;
    try {
      variants = JSON.parse(dataScript.textContent);
    } catch (err) {
      return;
    }

    var sectionId = productInfo.dataset.section;
    var selects = productInfo.querySelector('variant-selects');
    if (!selects) return;

    // Collect selected option values (by display value, matching variant.options)
    var selectedValues = Array.from(
      selects.querySelectorAll('fieldset input:checked')
    ).map(function (input) {
      return input.value;
    });

    // Find matching variant
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < v.options.length; j++) {
        if (v.options[j] !== selectedValues[j]) {
          match = false;
          break;
        }
      }
      if (match) {
        variant = v;
        break;
      }
    }

    if (!variant) return;

    // --- Update the hidden form input (fixes wrong variant added to cart) ---
    var form = productInfo.querySelector('#product-form-' + sectionId);
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // --- Update the displayed image (fixes image not switching) ---
    var mediaId = variant.featured_media_id;
    if (!mediaId) return;

    var productImages = productInfo.querySelector('product-images');
    var allMedia = productInfo.querySelectorAll('[data-image-id]');
    var targetMedia = productInfo.querySelector(
      '[data-image-id="' + mediaId + '"]'
    );

    if (targetMedia && allMedia.length) {
      allMedia.forEach(function (m) {
        m.classList.remove('media--active', 'media--hiding');
        m.classList.add('media--hidden');
      });
      targetMedia.classList.remove('media--hidden', 'media--hiding');
      targetMedia.classList.add('media--active');

      if (productImages) {
        productImages.setAttribute(
          'data-active-media',
          sectionId + '-' + mediaId
        );

        // Update height after image swap
        requestAnimationFrame(function () {
          var active = productImages.querySelector('.media--active');
          if (active) {
            productImages.style.setProperty(
              '--height',
              active.offsetHeight + 'px'
            );
          }
        });
      }
    }
  });
})();
